import React from 'react';
import clsx from 'clsx';

function BasicWaveLoader({ className }) {
    return <div className={clsx('wave-animation', className)} />;
}

export default BasicWaveLoader;
